import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2389644f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "message-area" }
const _hoisted_3 = {
  key: 0,
  class: "name"
}
const _hoisted_4 = {
  key: 1,
  ref: "dropdownRef",
  class: "dropdown-inner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-msg-replies" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_MessageReference = _resolveComponent("MessageReference")!
  const _component_MessageEmojiReact = _resolveComponent("MessageEmojiReact")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["message-bubble", [_ctx.message.flow === 'in' ? '' : 'reverse']]),
      ref: "htmlRefHook"
    }, [
      _createElementVNode("img", {
        class: "avatar",
        src: _ctx.message?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
        onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 8, _hoisted_1),
      _createElementVNode("main", _hoisted_2, [
        (_ctx.message.flow === 'in' && _ctx.message.conversationType === 'GROUP')
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.handleNickName(_ctx.message)) + " ", 1),
              _createVNode(_component_el_tag, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.message.nameCard), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.handleImageOrVideoBubbleStyle(_ctx.message)),
          onContextmenu: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)), ["prevent","right"]))
        }, [
          (_ctx.message?.cloudCustomData && _ctx.referenceMessage && _ctx.referenceMessage?.messageRootID)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["message-replie-area", [_ctx.message?.flow === 'in' ? '' : 'message-replies-area-reverse']]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRepliesDialog(_ctx.message, false)))
              }, [
                _createVNode(_component_MessageReference, {
                  message: _ctx.message,
                  referenceMessage: _ctx.referenceMessage,
                  referenceForShow: _ctx.referenceForShow,
                  url: _ctx.url,
                  face: _ctx.face,
                  allMessageID: _ctx.allMessageID,
                  type: "reply"
                }, null, 8, ["message", "referenceMessage", "referenceForShow", "url", "face", "allMessageID"])
              ], 2))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.dropdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["dialog", [_ctx.message.flow === 'in' ? '' : 'dialog-right']]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdown = false))
                }, [
                  _renderSlot(_ctx.$slots, "dialog", {}, undefined, true)
                ], 2)
              ], 512))
            : _createCommentVNode("", true),
          (_ctx.needEmojiReact && _ctx.isEmojiReactionInMessage(_ctx.message))
            ? (_openBlock(), _createBlock(_component_MessageEmojiReact, {
                key: 2,
                message: _ctx.message,
                type: "content"
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ], 34)
      ]),
      (_ctx.message.status === 'fail')
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "message-label fail",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resendMessage(_ctx.message)))
          }, "!"))
        : _createCommentVNode("", true),
      (_ctx.showReadReceiptTag(_ctx.message))
        ? (_openBlock(), _createElementBlock("label", {
            key: 1,
            class: _normalizeClass(["message-label", _ctx.readReceiptStyle(_ctx.message)]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showReadReceiptDialog(_ctx.message)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.readReceiptCont(_ctx.message)), 1)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.message?.cloudCustomData && _ctx.referenceMessage && !_ctx.referenceMessage?.messageRootID)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["message-reference-area", [_ctx.message.flow === 'in' ? '' : 'message-reference-area-reverse']]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jumpToAim(_ctx.referenceMessage)))
        }, [
          _createVNode(_component_MessageReference, {
            message: _ctx.message,
            referenceMessage: _ctx.referenceMessage,
            referenceForShow: _ctx.referenceForShow,
            url: _ctx.url,
            face: _ctx.face,
            allMessageID: _ctx.allMessageID,
            type: "reference"
          }, null, 8, ["message", "referenceMessage", "referenceForShow", "url", "face", "allMessageID"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.replies?.length)
      ? (_openBlock(), _createElementBlock("label", {
          key: 1,
          class: _normalizeClass(["message-replies", [_ctx.message.flow === 'in' ? '' : 'message-replies-reverse']]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showRepliesDialog(_ctx.message, true)))
        }, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.replies?.length + _ctx.$t('TUIChat.条回复')), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}